import useStore from "@/store"
import { ShiftStatus } from "@/store/session"
import { Navigate } from "react-router"

export default function HomePage() {
  const sessionStore = useStore.use.session()

  if (sessionStore.session.status === ShiftStatus.Started) {
    return <Navigate to="/manage-processes" />
  }

  return <Navigate to="/onboard-shift" />
}
